module.exports = __webpack_public_path__ + "img/lfcx3.73494b84.jpg";